// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xp-1";
export var printerIcon = "_xp-0";